export const SideBar = {
  baseStyle: {
    height: "100vh",
    borderWidth: "0 2px 0 0",
    borderStyle: "solid",
  },
  sizes: {},
  variants: {},
  defaultProps: {},
}